<template>
  <div>
    <div id="page-top-anchor"></div>
    <router-view />
  </div>
</template>

<script>
import pageContent from './pageContent'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'StaticPages',
  components: {
    pageContent
  },
  data () {
    return {
      tabs: [
        {
          name: 'Home',
          page: 'home'
        },
        {
          name: 'About',
          page: 'about'
        },
        {
          name: 'Venue',
          page: 'venue'
        },
        {
          name: 'FloorPlan',
          page: 'floor-plan'
        },
        {
          name: 'Contact',
          page: 'contact'
        },
        {
          name: 'Footer',
          page: 'footer'
        },
        {
          name: 'Attendee',
          page: 'attendee'
        },
        {
          name: 'Success Message',
          page: 'success message'
        },
        {
          name: 'Error Message',
          page: 'error message'
        },
        {
          name: 'Thank you page',
          page: 'thank-you'
        },
        {
          name: 'press-pack',
          page: 'press-pack'
        },
        {
          name: 'Registration errors',
          page: 'registration-errors'
        },
        {
          name: 'Registration text',
          page: 'registration-text'
        },
        {
          name: 'awards',
          page: 'awards'
        },
        {
          name: 'networking-blitz',
          page: 'networking-blitz'
        },
        {
          name: 'social',
          page: 'social'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['staticContent'])
  },
  methods: {
    ...mapActions(['fetchStaticContent'])
  },
  mounted () {
    this.fetchStaticContent()
    setTimeout(() => {
      this.$scrollTo('#page-top-anchor', 0)
    }, 500)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/StaticPages/index.vue